import React from "react";

export const IconLink = ({url, screenReaderLabel, icon, testid}) => (
  <a href={url} rel="noreferrer" target="_blank" className="text-gray-400 hover:text-gray-500" data-testid={testid}>
    <span className="sr-only">{screenReaderLabel}</span>
    {icon}
  </a>
)